export const calcArea = (item) => {
    return (item.width + parseInt(item.distance))
        * (item.height + parseInt(item.distance))
        * parseInt(item.counts) / 1000000;
};

export const priceCalc = (item, options) => {
    let result;
    if (item.type === 'etiketka') {
        result = item.price;
    } else if (item.paper.endsWith('_2')) {
        result = priceCalcMax(item, options);
    } else {
        result = priceCalcStandard(item, options);
    }

    let multiplier = 1;
    if (item.color === 'black') {
        const area = calcArea(item);
        if (area < 8) {
            multiplier = 0.85;
        } else if (area < 40) {
            multiplier = 0.85;
        } else {
            multiplier = 0.85;
        }
    }
    if (item.height < 25) {
        multiplier = 1.5 * multiplier;
    }
    if (item.width < 25) {
        multiplier = 1.5 * multiplier;
    }
    const finishPrice = Math.round(multiplier * result);
    return finishPrice > 1990 || item.type === 'etiketka' ? finishPrice : 1990;
};

const priceCalcMax = (item, options) => {
    const laminatePrice = 0
        + (item.laminate === 'mate_laminate' ? parseFloat(options.mate_laminate_2) : 0)
        + (item.laminate === 'glance_laminate' ? parseFloat(options.glance_laminate_2) : 0);

    const prices = options[item.paper].split(';').map(e => e.split('-')).map(e => {
        return {min: parseFloat(e[0]), max: parseFloat(e[1]), cost: parseFloat(e[2])}
    });

    const area = calcArea(item);

    const filteredPrices = prices.filter(e => area > e.min && area <= e.max);
    const result = filteredPrices.length === 0 ? prices[0].cost : filteredPrices[0].cost;


    const price = Math.floor((area + 100. / area) * (result * parseFloat(options.euro) + laminatePrice));

    console.log(
        'area=', area,
        'result=', result,
        'laminatePrice=', laminatePrice,
        'filteredPrices=', filteredPrices,
        'price=', price
    );
    return price;
};

const priceCalcStandard = (item, options) => {
    const laminatePrice = 0
        + (item.laminate === 'mate_laminate' ? parseFloat(options.mate_laminate) : 0)
        + (item.laminate === 'glance_laminate' ? parseFloat(options.glance_laminate) : 0);

    const price = Math.floor(
        calcArea(item)
        * (parseFloat(options[item.paper]) + laminatePrice)
        + parseFloat(options.multiplier_design)
    );

    console.log(
        'area=', calcArea(item),
        'md=', parseFloat(options.multiplier_design),
        'price=', parseFloat(options[item.paper]),
        'laminatePrice=', laminatePrice,
        'price=', price
    );

    return price < (parseInt(options[item.paper]) + laminatePrice)
        ? parseInt(options[item.paper]) + laminatePrice
        : price;
};

export const nearlyWeight = (item, options) => {
    return Math.round(
        calcArea(item, parseFloat(options.line_width))
        * parseFloat(options['weight_' + item.paper])
        * 1.2
    );
};

export const scrollToRefObject = (ref) => window.scrollTo(0, ref.current.offsetTop)
